module.exports = __webpack_public_path__ + "img/art-mobile.08910f65.png";